module.exports = __webpack_public_path__ + "static/media/18ECA42.28d893e6.jpg";